import type { TypedDocumentNode } from '@apollo/client';
import { gql } from '@apollo/client';
import { isPast } from 'date-fns';

import { useMonetaryAmount } from '@sorare/core/src/hooks/useMonetaryAmount';

import type { useIsPrimaryBuyLive_anyCard } from './__generated__/useIsPrimaryBuyLive.graphql';

export const useIsPrimaryBuyLive = (
  card: Nullable<useIsPrimaryBuyLive_anyCard>
) => {
  const { livePrimaryOffer, user } = card || {};
  const endDate = livePrimaryOffer?.endDate;
  const price = livePrimaryOffer?.price;
  const { toMonetaryAmount } = useMonetaryAmount();

  const ended = endDate && isPast(endDate);

  // Checking the token has an owner is mandatory as the
  // PrimaryOffer can ends way after the token has been sold
  const isOnSale = !!livePrimaryOffer && !user && !ended;

  const isPrimaryBuy = livePrimaryOffer?.cards.length === 1;

  if (isOnSale && price && endDate && isPrimaryBuy) {
    return {
      endDate,
      ended,
      price: toMonetaryAmount(price),
    };
  }
  return undefined;
};

useIsPrimaryBuyLive.fragments = {
  anyCard: gql`
    fragment useIsPrimaryBuyLive_anyCard on AnyCardInterface {
      slug
      livePrimaryOffer {
        id
        price {
          ...useMonetaryAmount_monetaryAmount
        }
        endDate
        cards: anyCards {
          slug
        }
      }
      user {
        slug
      }
    }
    ${useMonetaryAmount.fragments.monetaryAmount}
  ` as TypedDocumentNode<useIsPrimaryBuyLive_anyCard>,
};
